import React from 'react';
import { StyleSheet, keyframes, useStyles } from '@rexlabs/styling';

// Animation for the teal (green) path - swipes DOWN from top to bottom
const tealPathAnimation = keyframes({
  '0%': {
    clipPath: 'inset(0 0 100% 0)'
  },
  '10%': {
    clipPath: 'inset(0 0 100% 0)'
  },
  '40%': {
    clipPath: 'inset(0 0 0% 0)'
  },
  '100%': {
    clipPath: 'inset(0 0 0% 0)'
  }
});

// Animation for the navy (blue) path - swipes UP from bottom to top
const bluePathAnimation = keyframes({
  '0%': {
    clipPath: 'inset(100% 0 0 0)'
  },
  '25%': {
    clipPath: 'inset(100% 0 0 0)'
  },
  '60%': {
    clipPath: 'inset(0% 0 0 0)'
  },
  '100%': {
    clipPath: 'inset(0% 0 0 0)'
  }
});

const defaultStyles = StyleSheet({
  spinner: {
    alignSelf: 'center'
  },
  logo: {},
  tealPath: {
    animationName: tealPathAnimation,
    animationDuration: '3s',
    animationFillMode: 'forwards',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'normal',
    animationIterationCount: 'infinite'
  },
  bluePath: {
    animationName: bluePathAnimation,
    animationDuration: '3s',
    animationFillMode: 'forwards',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'normal',
    animationIterationCount: 'infinite'
  }
});

export interface RexSpinnerProps {
  size?: string | number;
}

export function RexSpinner({
  size = '150'
}: RexSpinnerProps): JSX.Element {
  const s = useStyles(defaultStyles);

  return (
    <div {...s('spinner')}>
      <svg
        {...s('logo')}
        height={size}
        viewBox='0 0 222 222'
        shapeRendering='geometricPrecision'
        textRendering='geometricPrecision'
      >
        {/* Teal path (left side) - swipes down */}
        <path
          {...s('tealPath')}
          d='M95.5586 150.232V131.502H91.6286C89.4086 131.502 87.4286 130.172 86.5786 128.122C85.7786 126.192 86.1486 124.012 87.4986 122.462L111.649 91.8218V59.6018C111.649 58.8418 110.729 58.4618 110.199 59.0018L74.3486 105.712C74.1886 105.872 74.0986 106.092 74.0986 106.312V145.052C74.0986 152.442 79.9886 158.442 87.3286 158.632C91.8786 158.532 95.5486 154.812 95.5486 150.242'
          fill='#3DE0BF'
        />
        {/* Navy path (right side) - swipes up */}
        <path
          {...s('bluePath')}
          d='M118.738 90.2917L91.0284 125.442C90.4884 125.982 90.8784 126.892 91.6284 126.892H99.3184C99.7884 126.892 100.168 127.272 100.168 127.742V150.232C100.168 157.422 94.3384 163.252 87.1484 163.252H124.058C131.568 163.252 137.658 157.162 137.658 149.652V127.742C137.658 127.272 138.038 126.892 138.508 126.892H147.048C147.808 126.892 148.188 125.972 147.648 125.442L119.938 90.2917C119.608 89.9617 119.068 89.9617 118.738 90.2917Z'
          fill='#0F2B66'
        />
      </svg>
    </div>
  );
}
